import style from "./ConsultationLayout.module.css";

export const InfoItem = ({ label, value, fullWidth = false }) => (
  <div className={`${style.infoItem} ${fullWidth ? style.infoItemFullWidth : ""}`}>
    <span className={style.infoLabel}>{label}</span>
    <span className={style.infoValue}>{value || "-"}</span>
  </div>
);
